import React from 'react';
import { Container } from '@components/Container';
import { Section } from '@components/Section';
import { MultiAppointmentForm } from './MultiAppointmentForm';

export const MultiAppointment = () => (
  <div className="main-content">
    <Container size="lg">
      <div className="panel">
        <Section containerSize="md">
          <MultiAppointmentForm />
        </Section>
      </div>
    </Container>
  </div>
);
